import React from "react";
import { Box, Stack, Typography, useTheme, Zoom } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BackgroundWrapper from "../BackgroundWrapper";
import { useAppSelector } from "../../store";
import { getRegistrationPhase } from "../../features/tournoi/tournoiSlice";
import {
  HomeGallery,
  HomeHighlights,
  HomeReglementCta,
  HomeWhyParticipate,
} from "./HomeMarketingSections";
import { HomePreOpenHero } from "./HomePreOpenHero";
import { HOME_PREOPEN_CARD_MAX_WIDTH_PX } from "./homeConstants";

const HomePreOpen: React.FC = () => {
  const theme = useTheme();
  const registrationPhase = useAppSelector(getRegistrationPhase);
  const tournoi = useAppSelector((state) => state.tournoi.tournoi);
  const dateOuverture = tournoi?.dateOuvertureInscriptions ?? null;
  const lieuDisplay =
    tournoi?.lieuCourt?.trim() || tournoi?.adresse?.trim() || null;
  const tournamentLabel = tournoi?.label?.trim() || "Tournoi national SQY Ping";

  return (
    <BackgroundWrapper>
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          pt: { xs: 0, sm: 0.5 },
          pb: { xs: 4, md: 6 },
          maxWidth: 1100,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
        }}
      >
        <HomePreOpenHero
          dateOuvertureInscriptions={dateOuverture}
          lieuDisplay={lieuDisplay}
          tournamentLabel={tournamentLabel}
          registrationPhase={
            registrationPhase === "preRegistration"
              ? "preRegistration"
              : "closed"
          }
        />

        <Zoom in>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="flex-start"
            justifyContent="center"
            sx={{
              width: "100%",
              maxWidth: HOME_PREOPEN_CARD_MAX_WIDTH_PX,
              mx: "auto",
              mb: { xs: 3, sm: 4 },
              px: { xs: 2, sm: 2.5 },
              py: { xs: 2, sm: 2.25 },
              borderRadius: 2,
              bgcolor:
                theme.palette.mode === "dark"
                  ? "rgba(255,255,255,0.06)"
                  : theme.palette.primary.main + "0a",
              border:
                theme.palette.mode === "dark"
                  ? `1px solid ${theme.palette.secondary.main}55`
                  : `1px solid ${theme.palette.divider}`,
            }}
          >
            <InfoOutlinedIcon
              sx={{
                fontSize: 22,
                flexShrink: 0,
                mt: 0.15,
                color:
                  theme.palette.mode === "dark"
                    ? "secondary.light"
                    : "primary.main",
              }}
              aria-hidden
            />
            <Typography
              variant="body2"
              sx={{
                textAlign: "left",
                lineHeight: 1.65,
                color:
                  theme.palette.mode === "dark"
                    ? "grey.200"
                    : theme.palette.text.secondary,
              }}
            >
              {registrationPhase === "preRegistration"
                ? "La pré-inscription est réservée aux clubs organisateurs. L’ouverture générale interviendra à la date indiquée ci-dessus."
                : "Les inscriptions en ligne grand public ne sont pas encore ouvertes : utilisez les boutons ci-dessus pour anticiper (page d’inscription, tableaux)."}
            </Typography>
          </Stack>
        </Zoom>

        <HomeGallery />
        <HomeHighlights />
        <HomeWhyParticipate />
        <HomeReglementCta />
      </Box>
    </BackgroundWrapper>
  );
};

export default HomePreOpen;
